import React from 'react';
import PrivateRoute from '../../components/common/PrivateRoute';
import {Switch, Route} from 'react-router-dom';
import PageError from "../../components/layout/PageError";
import AccessControl from "../../pages/authorized/AccessControl";
import Membership from "../../pages/authorized/Membership";
import Agent from "../../pages/authorized/Agent";
import Message from "../../pages/authorized/Message";
import Zone from "../../pages/authorized/Zone";
import Polling from "../../pages/authorized/Polling";
import Report from "../../pages/authorized/Report";
import Network from "../../pages/authorized/Network";
import AgentData from "../../pages/authorized/Agent/Data";
import Overview from "../../pages/authorized/Overview";

const Private = () => {

    return (
        <Switch>
            <PrivateRoute exact path="/dashboard" component={Overview} />
            <PrivateRoute exact path="/agent" component={Agent} />
            <PrivateRoute exact path="/agent/:id" component={AgentData} />
            <PrivateRoute exact path="/report" component={Report} />
            <PrivateRoute exact path="/message" component={Message} />
            <PrivateRoute exact path="/access_control" component={AccessControl} />
            <PrivateRoute exact path="/zone" component={Zone} />
            <PrivateRoute exact path="/polling" component={Polling} />
            <PrivateRoute exact path="/network" component={Network} />
            <Route component={PageError} />
        </Switch>
    )
};

export default Private;
